export const WEBBEDOUT_API_ENDPOINT = 'https://webbedout-be.onrender.com/';

export const apiPaths = {
  mainDetails: 'api/main-details',
  work: 'api/work',
  services: 'api/services',
  techStack: 'api/tech-stacks',
  team: 'api/team',
};
